/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import BandAdd from "./BandAdd";
import BandEdit from "./BandEdit";
import pr from "../lib/pr";
import { loginState, configState } from "../lib/State";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Band() {
  const [login, setLogin] = useState(loginState);
  const history = useHistory();
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");

  // 세션 로그인
  const get_session = async () => {
    const token = localStorage.getItem("token");
    const cid = configState.cid;
    let result = await axios.post(configState.api + "/hr/get_session", {
      cid: cid,
      token: token,
    });
    setLogin({ ccid: result.data.ccid, level: result.data.level });

    if (result.data.level !== "manager") {
      window.location.href = "/";
    } else {
      setLoaded(true);
    }
  };

  useEffect(() => {
    get_session();
  }, []);

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "band_no", headerName: "밴드번호", width: 120, align: "center" },
    { field: "serial", headerName: "시리얼", width: 200 },
    { field: "cname", headerName: "센터명", width: 160 },
  ];

  const onCloseAddPop = () => {
    setShowAdd(false); 
    get_list();
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    get_list();    
    setSeq(0); // 반복 열기
  };

  const onAddPopOpen = () => {
    setShowAdd(true);
  };

  useEffect(()=>{
    if(login.ccid !== undefined) {
      get_list();
    }
  },[login.ccid]);

  // 리스트
  const get_list = async () => {    
    let result = await axios.post(configState.api + "/hr/get_band", {
       token: token,
       ccid: login.ccid,
       level: login.level,
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);
    }
    else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // 수정창
  useEffect(() => {    
    if(seq > 0) {
      setShowEdit(true);
    }
  }, [seq]);

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <h3>밴드관리</h3>
          <div
            css={css`
              text-align: right;
              max-width: 900px;
              margin-bottom: 15px;
            `}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={onAddPopOpen}
            >
              밴드등록
            </Button>
          </div>

          <DataGrid
            css={css`
              max-width: 900px;
              min-height: 400px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onCellClick={(p, e) => {
              setSeq(p.id);
            }}
          />

          <Dialog
            open={showAdd}
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <BandAdd login={login} onCloseAddPop={onCloseAddPop}></BandAdd>
          </Dialog>

          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <BandEdit
              login={login}
              pSeq={seq}
              onCloseEditPop={onCloseEditPop}
            ></BandEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default Band;
